import React, { Children } from 'react'
import { Chip } from '@material-ui/core'
import ChipsProps from './Chips.types';
import './Chips.scss'


const Chips = (props: ChipsProps) => {
  
    return <Chip label={props.text} className={props.category}  />
};

export default Chips;
